module.exports = __webpack_public_path__ + "img/LATIN10_35.672e2068.jpg";